import { mapActions } from 'vuex'
import types from '../store/types'

const hideAppBar = {
    methods: {
        ...mapActions({
            hideAppBar: types.appBar.actions.hide
        })
    },
    mounted () {
        this.hideAppBar({ hide: true })
    },
    beforeDestroy () {
        this.hideAppBar({ hide: false })
    }
}

const hideMenu = {
    methods: {
        ...mapActions({
            setMenuBtn: types.appBar.actions.menuBtn,
        })
    },
    mounted () {
        this.setMenuBtn({ menuBtn: false })
    },
    beforeDestroy () {
        this.setMenuBtn({ menuBtn: true })
    }
}

const showBackBtn = {
    methods: {
        ...mapActions({
            setBackBtn: types.appBar.actions.backBtn
        })
    },
    mounted () {
        this.setBackBtn({ backBtn: true })
    },
    beforeDestroy () {
        this.setBackBtn({ backBtn: false })
    }
}

const showUtilBtn = {
    methods: {
        ...mapActions({
            setUtilBtn: types.appBar.actions.utilBtn
        })
    },
    mounted () {
        this.setUtilBtn({ utilBtn: true })
    },
    beforeDestroy () {
        this.setUtilBtn({ utilBtn: false })
    }
}

const showTitle = {
    methods: {
        ...mapActions({
            setTitle: types.appBar.actions.title
        })
    },
    mounted () {
        this.setTitle({ title: true })
    },
    beforeDestroy () {
        this.setTitle({ title: false })
    }
}

const showHomeBtn = {
    methods: {
        ...mapActions({
            setHomeBtn: types.appBar.actions.homeBtn
        })
    },
    mounted () {
        this.setHomeBtn({ homeBtn: true })
    },
    beforeDestroy () {
        this.setHomeBtn({ homeBtn: false })
    }
}

const setColor = {
    methods: {
        ...mapActions({
            setColor: types.appBar.actions.color
        })
    },
    mounted () {
        this.setColor({ color: true })
    },
    beforeDestroy () {
        this.setColor({ color: false })
    }
}

export default {
    hideMenu,
    hideAppBar,
    showBackBtn,
    showHomeBtn,
    showUtilBtn,
    showTitle,
    setColor
}

